import styled from 'styled-components';
import { Card, Text } from 'v3/components';
import theme from 'v3/theme';

export const ColumnsContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  max-height: 800px;
  padding-bottom: 1rem;
  grid-column-gap: 0.25rem;
  overflow: auto;
  scroll-behavior: smooth;
  ::-webkit-scrollbar {
    width: 0.45rem;
    height: 0.5rem;
  }
  ::-webkit-scrollbar-track {
    background: ${(props) => props.theme.colors.light_gray};
    opacity: 0.5;
  }
  ::-webkit-scrollbar-thumb {
    background: ${(props) => props.theme.colors.gray};
    border-radius: 10px;
  }
  & > div {
    display: flex;
    flex-direction: column;
  }
  @media (max-width: 1920px) {
    grid-template-columns: repeat(2, 1fr);
  }
  @media (max-width: 1439px) {
    grid-template-columns: 1fr;
  }
`;

export const StyledHeader = styled(Text)`
  text-transform: uppercase !important;
  font-weight: 500;
  color: #464e5f;
  margin-bottom: 0;
`;

export const GroupHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem;
  margin-bottom: 0.5rem;
`;

export const SelectGroupButton = styled.button`
  align-items: center;
  border: 1px solid ${({ $isDeselectAction }) => ($isDeselectAction ? '#d9534f' : theme.colors.light_blue)};
  border-radius: 4px;
  background: transparent;
  color: ${({ $isDeselectAction }) => ($isDeselectAction ? '#d9534f' : theme.colors.light_blue)};
  cursor: pointer;
  display: flex;
  height: 1.75rem;
  justify-content: center;
  width: 1.75rem;
  padding: 0.125rem;

  svg {
    height: 1.1rem;
    width: 1.1rem;
  }

  &:hover,
  &:focus {
    background: ${({ $isDeselectAction }) =>
      $isDeselectAction ? 'rgba(217, 83, 79, 0.08)' : 'rgba(95, 177, 243, 0.08)'};
    border-color: ${({ $isDeselectAction }) => ($isDeselectAction ? '#c9302c' : theme.colors.blue)};
    color: ${({ $isDeselectAction }) => ($isDeselectAction ? '#c9302c' : theme.colors.blue)};
    outline: none;
  }
`;

export const StyledCard = styled(Card)`
  box-shadow: 0px 0px 0px rgba(0, 0, 0, 0.1);
  & > div {
    display: flex;
    flex-direction: column;
  }
`;

export const ColumnItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  & > svg {
    cursor: help;
    color: ${theme.colors.light_blue};
  }
`;
